import { createLucideIcon } from 'lucide-react';

const LightingIcon = createLucideIcon('LightingIcon', [
  [
    'path',
    {
      d: 'M8.25 4.5C8.25 11.5312 4.5 12 4.5 16.2188C4.5 20.9062 7.625 23.25 12 23.25C16.375 23.25 19.5 20.9062 19.5 16.2188C19.5 12 15.75 11.5312 15.75 4.5',
      key: 'path-1',
      stroke: 'currentColor',
      strokeWidth: '2',
      fill: 'none',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
  ],
  [
    'path',
    {
      d: 'M8.25 1.5H15.75',
      key: 'path-2',
      stroke: 'currentColor',
      strokeWidth: '2',
      fill: 'none',
      strokeLinecap: 'round',
    },
  ],
]);

export default LightingIcon;
